/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractFormComponent } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { CheckboxTreeComponent, CheckboxTreeNode } from '@gh/common-internal-shared';
import { getRouteInitData, MutablePageState, UserContext } from '@gh/common-shared';
import { DialogService, FormMode, NotificationService, WaitingService } from '@gh/core-ui';
import { assign } from 'lodash';
import { buildCheckboxTreeModel, processModelSubtree } from '../../../utils/permission-tree-utils';
import {
  OfficeRolePermissionNode,
  OfficeRolePermissionTree,
} from '../../resources/office-role-permission-tree.model';

export abstract class AbstractOfficeRolePermissionsTabComponent extends AbstractFormComponent<OfficeRolePermissionTree> implements OnInit {
  permissionCheckboxTreeModel: CheckboxTreeNode<OfficeRolePermissionNode>[] = [];

  @ViewChild(CheckboxTreeComponent, { static: false }) tree: CheckboxTreeComponent<OfficeRolePermissionNode>;

  form: MutablePageState<OfficeRolePermissionTree>;

  protected route: ActivatedRoute;
  protected dialogService: DialogService;
  protected notificationService: NotificationService;
  protected waitingService: WaitingService;
  protected userContext: UserContext;

  ngOnInit(): void {
    const { permissionTree, ...init } = getRouteInitData(this.route);
    assign(this, init);

    this.form = new MutablePageState(
      this.userContext.hasPermission(BuilderPermission.Setup.Manager.Roles.Permissions.EDIT)
        ? FormMode.EditMode : FormMode.ViewMode,
      permissionTree);
    this.permissionCheckboxTreeModel = buildCheckboxTreeModel(this.treeToDisplayedNodes(permissionTree));
  }

  onExpandAll(): void {
    this.tree.expandAll();
  }

  onCollapseAll(): void {
    this.tree.collapseAll();
  }

  onPermissionChange(rootNode: CheckboxTreeNode<OfficeRolePermissionNode>): void {
    this.form.setDirty();

    processModelSubtree(rootNode, (node) => {
      node.value.allowed = node.checked;
    });
  }

  protected refresh(tree: OfficeRolePermissionTree): void {
    this.permissionCheckboxTreeModel = buildCheckboxTreeModel(this.treeToDisplayedNodes(tree));
    this.form.setValue(tree);
    this.form.resetDirty();
  }

  protected treeToDisplayedNodes(tree: OfficeRolePermissionTree): OfficeRolePermissionNode[] {
    return tree.roots;
  }
}
